import type { ObjectMapping } from '@shared/types/utils';

export const TranslationState: ObjectMapping = {
  ORIGINAL: 'ORIGINAL',
  PENDING: 'PENDING',
  TRANSLATED: 'TRANSLATED',
  FAILED: 'FAILED',
};
